import { createContext, useContext } from 'react';
import { usePersistentState } from '../hooks/usePersistentState';

const TripContext = createContext();

export const TripProvider = ({ children }) => {
    const [tripData, setTripData] = usePersistentState('tripData', null);

    return (
        <TripContext.Provider value={{ tripData, setTripData }}>
            {children}
        </TripContext.Provider>
    );
};

export const useTrip = () => useContext(TripContext);
